import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { FaFacebookF, FaTwitter } from "react-icons/fa";

const ApiFooter = () => {
    return (
        <Row className=" w-100  m-0 bg-white py-5">
            <Col xs="12 py-4">
                <hr></hr>
                <div className="text-center py-2">
                    <h6 className="fs--16 fw--500 text-muted">
                        ©2009-2024{" "}
                        <Link to="" className="text-site-primary">
                            Golfbert Data Services
                        </Link>
                        . All rights reserved. The content of this page and code
                        samples are provided by and the rights of Golfbert Inc.
                        <Link to="" className="text-site-primary">
                            License Agreement.
                        </Link>
                    </h6>
                </div>

                <div className="d-flex justify-content-center">
                    <div className="text-site-primary footer-icon">
                        <FaFacebookF />
                    </div>
                    <div>
                        <FaTwitter className="text-site-primary footer-icon ml-4" />
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export default ApiFooter;
